import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cosun',
  templateUrl: './cosun.component.html',
  styleUrls: ['./cosun.component.scss']
})
export class CosunComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
